// -----------------------------------------------------------------------------
// Libraries
// -----------------------------------------------------------------------------
import React, { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

// -----------------------------------------------------------------------------
// Store
// -----------------------------------------------------------------------------
import { useGetMixQuery } from '../../store/queries/rows';

// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { Heading1, Paragraph1 } from '../../theme/theme-provider/typography';

// -----------------------------------------------------------------------------
// Styles
// -----------------------------------------------------------------------------
import StyledRowCard from './styles';

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const RowCard = ({ rowData, setTrack, index, length }) => {
  const [firstLoad, setFirstLoad] = useState(true);
  const { data, isLoading } = useGetMixQuery({ rowData });

  useEffect(() => {
    if (!isLoading && data && index === length - 1 && firstLoad) {
      setTrack(data.items[0], true);
      setFirstLoad(false);
    }
  }, [index, data, isLoading, length, firstLoad, setTrack]);

  return (
    <StyledRowCard>
      <div className="fr-row-card">
        {isLoading && (
          <div className="fr-row-card__loading-container">
            <LoadingOutlined spin />
          </div>
        )}
        {!isLoading && data && (
          <div
            className="fr-row-card__content"
            style={{ backgroundImage: `url(${data.items[0].featured_image})` }}
            onClick={() => setTrack(data.items[0], false)}
          >
            <div className="fr-row-card__content__title">
              <Heading1>{data.items[0].mix_title}</Heading1>
              <Paragraph1>{data.items[0].dj_name}</Paragraph1>
            </div>
            <div className="fr-row-card__content__bottom">
              <Paragraph1>{data.items[0].lower_left}</Paragraph1>
              <Paragraph1>{data.items[0].lower_right}</Paragraph1>
            </div>
          </div>
        )}
      </div>
    </StyledRowCard>
  );
};

export default RowCard;
